import { useEffect, useState } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";

const UndoComponent = ({
  activeArray,
  pendingRemovedArray,
  undoAction,
  showToast,
}) => {
  const { getUserData } = useUser();
  const { getTextByKey } = useContent();
  const [loading, setLoading] = useState(true);

  const handleClick = () => {
    undoAction({
      mailsArray: activeArray.length > 0 ? activeArray : pendingRemovedArray,
      mailStatus: "pendingRemoved",
      userId: getUserData().UserId,
      showToast: () => {},
      setLoadingStatus: setLoading,
    });
  };

  useEffect(() => {
    if (!loading) {
      showToast?.();
    }
  }, [loading]);

  return (
    <div onClick={handleClick} className="undo-action">
      {getTextByKey("undo-remove-text")}
    </div>
  );
};

export const MailRemovedNotification = ({
  mailStatus,
  activeArray,
  pendingRemovedArray,
  undoAction,
  showToast,
}) => {
  const { getTextByKey } = useContent();

  return ["active", "saved", "sent", "removed"].includes(mailStatus) ? (
    <>
      {getTextByKey("remove-mail-notification")}
      <UndoComponent
        {...{ activeArray, pendingRemovedArray, undoAction, showToast }}
      />
    </>
  ) : (
    getTextByKey("unremove-mail-notification")
  );
};
